import React, { forwardRef } from "react";
import { Card } from "@mui/material";

const DSCard = forwardRef<HTMLDivElement, React.ComponentProps<typeof Card>>(
  (props, ref) => <Card ref={ref} {...props} />,
);

export default DSCard;
